import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiCheck, FiMenu } from 'react-icons/fi'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'

import Modal from '../../../shared/modal/Modal'
import api from '../../../utils/api'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import EditChecklistItem from '../EditChecklistItem'
import useFlashMessage from '../../../hooks/useFlashMessage'
import useMyPermission from '../../../hooks/useMyPermission'

function ListChecklistItemRow({ dataArray, handleOnSuccess, selectItem, selectedData, onToggleSelect, myPermission, onReorder, dragEnabled }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const { checkPermission } = useMyPermission()
    const myPermissionEdit = checkPermission(myPermission, "checklistItem_Edit")
    const myPermissionDelete = checkPermission(myPermission, "checklistItem_Delete")

    const [modalEditChecklistItem, setModalEditChecklistItem] = useState(false)
    const [checklistItemId, setChecklistItemId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [checklistItemName, setChecklistItemName] = useState("")

    const isSelected = (item) => !!(selectedData || []).find((i) => i._id === item._id)
    const canDrag = dragEnabled && !selectItem && myPermissionEdit && !!onReorder

    async function deleteChecklistItem(id) {
        let msgType = 'success'
        const data = await api.delete(`/checklistItem/delete/${id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            handleOnSuccess()
            setModalDeleteItem(false)
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
    }

    function handleDragEnd(result) {
        if (!result.destination || result.destination.index === result.source.index) return
        const reordered = Array.from(dataArray)
        const [moved] = reordered.splice(result.source.index, 1)
        reordered.splice(result.destination.index, 0, moved)
        onReorder(reordered)
    }

    return (
        <div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="checklist-items" isDropDisabled={!canDrag}>
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {dataArray && dataArray.map((item, index) => (
                                <Draggable key={item._id} draggableId={item._id} index={index} isDragDisabled={!canDrag}>
                                    {(dragProvided, dragSnapshot) => (
                                        <div
                                            ref={dragProvided.innerRef}
                                            {...dragProvided.draggableProps}
                                            className={[
                                                'pg-item',
                                                selectItem ? 'pg-item-selectable' : '',
                                                isSelected(item) ? 'pg-item-selected' : '',
                                                dragSnapshot.isDragging ? 'pg-item-dragging' : '',
                                            ].join(' ')}
                                            onClick={() => selectItem && onToggleSelect(item)}
                                        >
                                            {canDrag && (
                                                <span
                                                    className="pg-drag-handle"
                                                    {...dragProvided.dragHandleProps}
                                                    title="Arrastar para reordenar"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <FiMenu size={16} />
                                                </span>
                                            )}
                                            <div className="pg-item-main">
                                                <div className="pg-item-header">
                                                    <span className="pg-item-name">{item.name}</span>
                                                    {item.fillType?.label && (
                                                        <span className={`ci-fill-type-badge ci-fill-type-${item.fillType.value}`}>
                                                            {item.fillType.label}
                                                        </span>
                                                    )}
                                                    {item.disabled && (
                                                        <span className="pg-item-status-disabled">Desabilitado</span>
                                                    )}
                                                </div>
                                                <span className="ci-item-order">Ordem: {item.order ?? 0}</span>
                                            </div>

                                            {selectItem ? (
                                                <div className={`pg-item-checkbox ${isSelected(item) ? 'pg-item-checkbox-checked' : ''}`}>
                                                    <FiCheck size={14} />
                                                </div>
                                            ) : (
                                                <div className='shd-row-box-item-action'>
                                                    {myPermissionEdit &&
                                                        <FaPencilAlt
                                                            className='shd-icon-row-edit'
                                                            title='Editar'
                                                            onClick={() => { setChecklistItemId(item._id); setModalEditChecklistItem(true) }}
                                                        />
                                                    }
                                                    {myPermissionDelete &&
                                                        <FaTrashAlt
                                                            className='shd-icon-row-trash'
                                                            title='Apagar'
                                                            onClick={() => { setModalDeleteItem(true); setChecklistItemId(item._id); setChecklistItemName(item.name) }}
                                                        />
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            <Modal
                modalStatus={modalEditChecklistItem}
                changeStatus={setModalEditChecklistItem}
                w={60}
                content={
                    <EditChecklistItem
                        id={checklistItemId}
                        handleOnSuccess={() => { setModalEditChecklistItem(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditChecklistItem(false)}
                    />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteChecklistItem(checklistItemId)}
                message="Deseja realmente excluir esse item?"
                itemName={checklistItemName}
            />
        </div>
    )
}

export default ListChecklistItemRow
